module.exports = __webpack_public_path__ + "img/quote.36541e0b.svg";